import './components';
import './stores';

import {
  makeCarousel,
  makeUnmountedCarousel,
} from '../../auto/utils/carousel/splide';

window.makeCarousel = makeCarousel;
window.makeUnmountedCarousel = makeUnmountedCarousel;
